import { DialogPosition } from '@ecdlink/ui';
const getItemPosition = (position) => {
    switch (position) {
        case DialogPosition.Top:
            return 'items-start';
        case DialogPosition.Bottom:
            return 'items-end';
        case DialogPosition.Middle:
            return 'items-center';
        default:
            return '';
    }
};
export const transitionRoot = 'z-10 ';
export const transitionChildWrapper = (position) => `flex ${getItemPosition(position)} justify-center min-h-screen  ${position !== DialogPosition.Full ? 'pt-4 px-4' : 'h-screen'} text-center`;
export const overlay = 'fixed inset-0 opacity-50 bg-gray-500';
export const contentWrapper = (position) => `align-bottom max-h-screen overflow-y-auto ${position !== DialogPosition.Full
    ? 'rounded-2xl max-w-sm mb-10'
    : 'max-w-4xl'} text-left shadow-xl transform transition-all align-middle w-full`;
//# sourceMappingURL=dialog.styles.js.map